<script>
export default {
  name: 'ChipsAutocomplete',
  props: {
    label: {
      type: String,
      default: () => '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    itemValue: {
      type: String,
      default: () => 'id',
    },
    itemDisplay: {
      type: Function,
      default: o => o,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: Array,
      default: () => [],
    },
    prependInnerText: {
      type: String,
      default: () => '',
    },
  },
  emits: [
    'search',
    'update:modelValue',
  ],
  methods: {
    onSearch (event) {
      this.$emit('search', event.target.value)
    },
    onUpdateModelValue (newValue) {
      this.$emit('update:modelValue', newValue)
    },
  },
}
</script>
<template>
  <v-autocomplete
    :model-value="modelValue"
    clear-on-select
    hide-selected
    multiple
    closable-chips
    color="secondary"
    :items="items"
    :label="label"
    :item-title="itemDisplay"
    :item-value="itemValue"
    :disabled="disabled"
    :rules="rules"
    :hide-details="hideDetails"
    @keydown="onSearch"
    @update:model-value="onUpdateModelValue"
  >
    <template v-slot:chip="{ props }">
      <v-chip
        v-bind="props"
        variant="elevated"
        color="secondary"
      />
    </template>
    <template v-slot:prepend-inner="{ props }">
      <v-chip
        v-if="prependInnerText"
        class="prepend-chip"
        v-bind="props"
        variant="elevated"
        color="secondary"
        :text="prependInnerText"
      />
    </template>
  </v-autocomplete>
</template>
<style lang="scss" scoped>
.prepend-chip {
  margin-top: 1.2rem;
  font-size: 0.75rem !important;
  opacity: 0.9;
}
</style>
